
import LoaderGif from "../../Assets/loader.gif";
const LoadingScreen = () => {
   return( <div className="loader-wrapper">
    <div
    style={{
        height: "100%",
        width: "100%",
        display: "grid",
        placeItems: "center",
    }}
    >
    <img style={{ width: "500px" }} src={LoaderGif} alt="Loader" />
    </div>
    </div>)
}
export default LoadingScreen;